export default "__VITE_ASSET__CxuchZNO__"